export default (value) => value / 100;
